import { ApiEnum } from "./api-enum";
import { BaseRequest } from "./core/base-request";
import type {
  BaseResponse,
  IAuthCallbackResponse,
  IDeleteAccountResponse,
  ILoginInfoResponse,
  IRequestLoginResponse,
  IStripeConnect,
  ISubscriptionItem,
  RequestLoginOptions,
  VerifyLoginOptions,
} from "./types";

export class AuthService extends BaseRequest {
  public static connectStripe(): Promise<BaseResponse<{ url: string }>> {
    return AuthService._post(ApiEnum.StripeConnect, {}, { requiredAuth: true });
  }

  public static refreshStripe(): Promise<BaseResponse<{ stripeConnect: IStripeConnect | null }>> {
    return AuthService._post(ApiEnum.StripeRefresh, {}, { requiredAuth: true });
  }

  public static async requestLogin(options: RequestLoginOptions): Promise<BaseResponse<IRequestLoginResponse | null>> {
    return AuthService._post<IRequestLoginResponse | null>(
      ApiEnum.RequestLogin,
      { email: options.email, ...(options.turnstileToken ? { turnstileToken: options.turnstileToken } : {}) },
      { requiredAuth: options.requiredAuth, mapperKey: ApiEnum.RequestLogin },
    );
  }

  public static async verifyLogin(options: VerifyLoginOptions): Promise<BaseResponse<IAuthCallbackResponse>> {
    return AuthService._post<IAuthCallbackResponse>(
      ApiEnum.VerifyLogin,
      { email: options.email, code: options.code },
      { requiredAuth: options.requiredAuth, mapperKey: ApiEnum.VerifyLogin },
    );
  }

  public static loginWithGoogleOneTap(credential: string, nonce: string): Promise<BaseResponse<IAuthCallbackResponse>> {
    return AuthService._post<IAuthCallbackResponse>(
      ApiEnum.AuthGoogleOneTap,
      { credential, nonce },
      {
        mapperKey: ApiEnum.AuthGoogleOneTap,
        disabledToast: true,
      },
    );
  }

  public static async getLoginInfo(): Promise<BaseResponse<ILoginInfoResponse>> {
    return AuthService._get<ILoginInfoResponse>(ApiEnum.GetLoginInfo, {}, { requiredAuth: true, mapperKey: ApiEnum.GetLoginInfo });
  }

  public static async deleteAccount(confirmEmail: string): Promise<BaseResponse<IDeleteAccountResponse>> {
    return AuthService._post<IDeleteAccountResponse>(
      ApiEnum.DeleteAccount,
      { confirmEmail },
      { requiredAuth: true, mapperKey: ApiEnum.DeleteAccount },
    );
  }

  public static async unsubscribe(token: string): Promise<BaseResponse<null>> {
    return AuthService._post<null>(ApiEnum.Unsubscribe, { token }, { requiredAuth: false, mapperKey: ApiEnum.Unsubscribe });
  }
}
